import { Check, CheckCheck, Clock, Ban } from 'lucide-react';
import { WHATSAPP_MESSAGE_STATUS as S, statusLabel } from '../../utils/whatsapp';
import { whatsappTheme } from './whatsappTheme';

const { colors } = whatsappTheme;

/** status -> [icon component, colour]. Failed is a red "!" and is handled separately. */
const TICKS = {
  [S.QUEUED]: [Clock, colors.textSecondary],
  [S.SENDING]: [Clock, colors.textSecondary],
  [S.SENT]: [Check, colors.textSecondary],
  [S.DELIVERED]: [CheckCheck, colors.textSecondary],
  [S.READ]: [CheckCheck, colors.readTick],
  [S.SKIPPED]: [Ban, colors.textSecondary],
};

/**
 * WhatsApp delivery state: one grey tick (sent), two grey (delivered), two blue (read), a clock
 * (queued or sending), a red "!" (failed). Renders nothing without a status.
 * @param {{status?: string | null}} props
 */
const MessageTicks = ({ status }) => {
  if (!status) return null;
  const label = statusLabel(status);
  const common = { role: 'img', 'aria-label': label, title: label, className: 'inline-flex items-center' };

  if (status === S.FAILED) {
    return (
      <span {...common} style={{ color: colors.error }} className="inline-flex items-center text-[13px] font-bold leading-none">
        !
      </span>
    );
  }
  const [Icon, color] = TICKS[status] ?? TICKS[S.SENT];
  return (
    <span {...common} style={{ color }}>
      <Icon aria-hidden="true" className="h-4 w-4" strokeWidth={2.25} />
    </span>
  );
};

export default MessageTicks;
